import { render, staticRenderFns } from "./link-paper.vue?vue&type=template&id=fc39136e&scoped=true&"
import script from "./link-paper.vue?vue&type=script&lang=js&"
export * from "./link-paper.vue?vue&type=script&lang=js&"
import style0 from "./link-paper.vue?vue&type=style&index=0&id=fc39136e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc39136e",
  null
  
)

export default component.exports